<daui-dialog [isShow]="isShow">
  <div class="dialog-wrapper">
    <div class="dialog-wrapper-title">
      <div class="left"><span>Are you still here?</span></div>
      <div class="center"></div>
      <div class="right"></div>
    </div>
    <div class="dialog-wrapper-body">
      <div class="title">Are you still using this kiosk?</div>
      <div class="title">This kiosk will automatically reset in {{ countdown }} seconds</div>
    </div>
    <div class="dialog-wrapper-footer">
      <button class="end" (click)="end()" [disabled]="isRunningProcess">
        <span class="label">END PROCESS</span>
      </button>
      <button class="continue" (click)="continue()" [disabled]="isRunningProcess">
        <span class="label">CONTINUE</span>
      </button>
    </div>
  </div>
</daui-dialog>
